import React from 'react';
import ReportCircleProgressChart from './ReportCircleProgressChart.jsx';
import ReportProgressBarComponents from './ReportProgressbarComponent.jsx';
import { useTranslation } from '../../hooks/useTranslation';
const score = (val) => (typeof val === 'number' && !Number.isNaN(val) ? val : null);
// const pctLabel = (val) => (val == null ? '-' : `${Math.round(val)}%`);

const groupDefs = [
  {
    key: 'environment',
    title: 'Miljö',
    items: [
      { key: 'climate_score', label: 'Klimat' },
      { key: 'water_score', label: 'Vatten' },
      { key: 'biodiversity_score', label: 'Biologisk mångfald' },
      { key: 'transport_score', label: 'Transport' },
      { key: 'land_use_score', label: 'Landanvändning' },
      { key: 'fertilizers_use_score', label: 'Övergödning' },
      { key: 'pesticides_use_score', label: 'Bekämpningsmedel' },
    ],
  },
  {
    key: 'health',
    title: 'Hälsa',
    items: [
      { key: 'health_score', label: 'Hälsa' },
      { key: 'antibiotics_resistance_score', label: 'Antibiotikaresistens' },
    ]
  },
  {
    key: 'social',
    title: 'Rättvisa',
    items: [
      { key: 'social_justice_score', label: 'Social rättvisa' },
      { key: 'child_labor_score', label: 'Barnarbete' },
      { key: 'animal_protection_score', label: 'Djurvälfärd' },
      { key: 'worker_rights_score', label: 'Arbetsförhållanden' },
      { key: 'equality_score', label: 'Jämlikhet' },
      { key: 'local_population_score', label: 'Lokalbefolkning' }
    ],
  },
];

const ParametersGroups = ({ dish, darkMode = false }) => {
  const { t } = useTranslation();
  if (!dish) return null;

  const renderGroup = (group) => {
    const values = group.items
      .map((it) => ({ ...it, value: score(dish[it.key]) }))
      .filter((it) => it.value != null);

    if (values.length === 0) return null;

    // Compute average; for health, base only on 'health_score' (exclude antibiotics_resistance_score)
    // Compute average; for health, base only on 'health_score' (exclude antibiotics_resistance_score)
    const valuesForAverage =
      group.key === 'health'
        ? values.filter((it) => it.key === 'health_score')
        : values.filter((it) => it.value != null && it.value > 0); // 🚀 ignore 0 values

    const average =
      valuesForAverage.length > 0
        ? Math.round(
          valuesForAverage.reduce((sum, it) => sum + it.value, 0) /
          valuesForAverage.length
        )
        : 0;


    return (
      <div key={group.key} className="bg-gray-100 rounded-2xl border border-gray-200 py-4 px-1.5 print:px-1 print:py-3">
        <div className="flex flex-col items-center justify-center mb-3 gap-2 print:mb-2 print:gap-1">
          <div className="flex  gap-0 items-center space-x-2">
            <h4 className="text-2xl font-extrabold text-gray-900">{ t(group.title)}</h4>
            <img src={`/assets/icons/svg/${(group.title === "Miljö" ? "Miljo" : group.title === "Hälsa" ? "Halsa" : "Rattvisa")}.svg`} alt="Poäng" className="w-6 h-6" />
          </div>
          <ReportCircleProgressChart value={average} size={120} strokeWidth={12} showCaption />
        </div>
        <ReportProgressBarComponents items={values} darkMode={darkMode} groupKey={group.key} highlightIndex={null} sectionNote={
          group.key === 'health'
            ? `${t('Hälsopoängen baseras enbart på Hälsa:')}`
            : `${t('I denna kategori ingår följande parametrar:')}`
        } 
        iconSize={28}
        />
      </div>
    );
  };


  return (
    <div className="space-y-4 print:space-y-2">
      <div className="grid grid-cols-1 tablet:grid-cols-3 laptop:grid-cols-3 desktop:grid-cols-3 gap-2 print:gap-1">
        {groupDefs.map((g) => renderGroup(g))}
      </div>
    </div>
  );
};

export default ParametersGroups;


